module.exports = __webpack_public_path__ + "static/media/img116_R.b8cdeda7.jpg";